import { render } from "./creche.vue?vue&type=template&id=f9a60c9a&scoped=true"
import script from "./creche.vue?vue&type=script&lang=js"
export * from "./creche.vue?vue&type=script&lang=js"

import "./creche.vue?vue&type=style&index=0&id=f9a60c9a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a60c9a"]])

export default __exports__